import React from 'react';
import { useTranslation } from '../i18n/useTranslation';
const Platforms = () => {
  const {
    t
  } = useTranslation();
  const platformLogos = [{
    name: 'Facebook',
    logo: 'https://cdn.worldvectorlogo.com/logos/facebook-3-2.svg'
  }, {
    name: 'Shopify',
    logo: 'https://cdn.worldvectorlogo.com/logos/shopify.svg'
  }, {
    name: 'Magento',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/5/55/Magento_Logo.svg'
  }, {
    name: 'WooCommerce',
    logo: 'https://cdn.worldvectorlogo.com/logos/woocommerce.svg'
  }, {
    name: 'Messenger',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/b/be/Facebook_Messenger_logo_2020.svg'
  }, {
    name: 'Telegram',
    logo: 'https://cdn.worldvectorlogo.com/logos/telegram-1.svg'
  }, {
    name: 'WhatsApp',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg'
  }];
  return <section id="platforms" className="py-16 bg-gray-50" data-id="element-2081">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2082">
        <div className="text-center mb-12" data-id="element-2083">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2084">
            {t('sections.platforms.title')}
          </h2>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12" data-id="element-2085">
          {platformLogos.map((platform, index) => <div key={index} className="flex flex-col items-center" data-id="element-2086">
              <img src={platform.logo} alt={platform.name} className="h-12 md:h-16 w-auto grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300" data-id="element-2087" />
              <span className="text-xs text-gray-500 mt-2" data-id="element-2088">
                {platform.name}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Platforms;